import React from "react";
import Button from "@/ui/Button/Button";
import { useAdminPriceEdaContext } from "./context";
import cls from "./styles.module.scss";

export const EditorTariffSwitch = () => {
  const {
    editor: { edaTarget, setEdaTarget },
  } = useAdminPriceEdaContext();

  return (
    <div className={cls.sidebarSection}>
      <div className={cls.sidebarLabel}>EDA тариф</div>
      <div className={cls.modeSwitch}>
        <Button
          type="button"
          label="Авто"
          variant="outlined"
          onClick={() => setEdaTarget("eda_car")}
          className={
            edaTarget === "eda_car" ? cls.modeButtonActive : cls.modeButton
          }
        />
        <Button
          type="button"
          label="Вело"
          variant="outlined"
          onClick={() => setEdaTarget("eda_velo")}
          className={
            edaTarget === "eda_velo" ? cls.modeButtonActive : cls.modeButton
          }
        />
      </div>
    </div>
  );
};
